import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            分类导览
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按类型浏览雏田同人作品，快速找到你感兴趣的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-start gap-4 p-5 bg-background-50 rounded-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                <i className={`${cat.icon} text-xl text-accent-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 mb-2 line-clamp-2">
                  {cat.description}
                </p>
                <span className="text-xs text-accent-600 font-medium">
                  {cat.count} 部作品
                </span>
              </div>
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 self-center">
                <i className="ri-arrow-right-s-line text-foreground-300"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}